import React from "react";
import { Divider } from "@mui/material";
import CustomMenuItem from "../../../../../components/Menu/CustomMenuItem";
import EditEpic from "./EditEpic";

const MilestoneItem = ({
  item,
  epic,
  showEditArea,
  hoveredIndex,
  boardNameTitle,
  onMouseEnter,
  onMouseLeave,
  onClick,
  setShowEditArea,
  showDivider = true,
}) => {
  return (
    <React.Fragment>
      <CustomMenuItem
        className="menu-item-large"
        onMouseEnter={() => onMouseEnter(item?.epic_id)}
        onMouseLeave={onMouseLeave}
        onClick={() => onClick(item?.epic_id)}>
        <div className="epic-name-id-div">
          <p
            className={
              epic.indexOf(item?.epic_id) > -1
                ? "active-epic-name"
                : "epic-name"
            }>
            {showEditArea && hoveredIndex === item.epic_id ? (
              <EditEpic
                epicId={item.epic_id}
                epicName={item?.epic_name}
                setShowEditArea={setShowEditArea}
              />
            ) : (
              item?.epic_name
            )}
          </p>
          <p className="epic-id">
            {!showEditArea && `${boardNameTitle} - ${item?.epic_id}`}
          </p>
        </div>
      </CustomMenuItem>
      {showDivider && <Divider />}
    </React.Fragment>
  );
};

export default MilestoneItem;
